;(function ($) {

    const ResetPaginationOnFilterChange = {

        init() {
            $(document).ready(() => {
                this.bindFilterForms();
                this.bindTabFilters();
            });
        },

        stripPagination(url) {
            url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');
            url.searchParams.delete('paged');
            url.searchParams.delete('page');
            return url;
        },

		/**
		 * Remove pagination parameters from the URL when a filter form is submitted,
		 * so that users are taken to the first page of results for their new filter criteria.
		 *
		 * The `e.preventDefault()` has the possibility to cause issues in future
		 * (e.g. if it prevented GTM from tracking form submissions).
		 * In future we might want to more reliably write out `action` attributes on the forms,
		 * so that this function is not needed.
		 */
        bindFilterForms() {
            $('.query-loop__filter-form').on('submit', (e) => {
                e.preventDefault();

                const url = this.stripPagination(new URL(window.location.href));

                new FormData(e.currentTarget).forEach((value, key) => {
                    if (value) {
                        url.searchParams.set(key, value);
                    } else {
                        url.searchParams.delete(key);
                    }
                });

                window.location.href = url.toString();
            });
        },

		/**
		 * Remove pagination parameters from the URL when tab filters are clicked.
		 *
		 * The `e.preventDefault()` has the possibility to cause issues in future
		 * (e.g. if it prevented GTM from tracking form submissions).
		 * In future we might want to more reliably write out fully-qualified URLs in the `href` attributes of the tab links, so that this function is not needed.
		 *
		 * Also note, .tab-filter elements are not written by the parent theme directly,
		 * but are commonly used by child themes (IFEAT, BJUI, ASI). Check that all child-theme uses have been removed before removing this function.
		 */
        bindTabFilters() {
            $('.tab-filter a.tab').on('click', (e) => {
                e.preventDefault();
                const url = this.stripPagination(new URL(e.currentTarget.href, window.location.href));
                window.location.href = url.toString();
            });
        },

    };

    ResetPaginationOnFilterChange.init();

}(jQuery));